import { motion } from 'framer-motion'

import { aboutData } from '../../data/site-data'

import './styles.scss'

export const About = () => {
    return (
        <section className="about" id='about'>
            <article className="container">
                <div className="row">
                    <div className="col about-info">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: .1, duration: .5 }}
                            viewport={{ once: true }}
                        >
                            <h3>{aboutData.name}</h3>
                            <span className='button hi-button'><img className='logo' src='./assets/logo.png' /></span>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: .3, duration: .5 }}
                            viewport={{ once: true }}
                        >
                            {aboutData.description.map((el, idx) => {
                                return (<p key={idx} className="site-description">{el}</p>)
                            })}
                        </motion.div>
                    </div>


                </div>
            </article>
        </section>
    )
}